// extracted by mini-css-extract-plugin
export var chevron = "_im-3";
export var chevronRotated = "_im-4";
export var image = "_im-1";
export var imageContainer = "_im-0";
export var shippingAddress = "_im-2";